<div [class]="backgroundColour">
  <span class="inner">{{ initials }}</span>
</div>
